import { z } from 'zod';

export const audioDetailSchema = z.object({
  id: z.number(),
  duration: z.number(),
  magnitudeList: z.array(z.number())
});

export const fileSchema = z.object({
  id: z.number(),
  originalName: z.string(),
  name: z.string(),
  size: z.number(),
  contentType: z.string(),
  path: z.string(),
  absolutePath: z.string(),
  thumbAbsolutePath: z.string().nullable().optional(),
  smallestAbsolutePath: z.string().nullable().optional(),
  format: z.string(),
  type: z.string(),
  createdDate: z.string(),
  createdTimestamp: z.number().nullable().optional(),
  createdBy: z.string(),
  audioDetail: audioDetailSchema.nullable().optional(),
  uuid: z.string(),
  companyUUID: z.string(),
  status: z.string().optional()
});

export type File = z.infer<typeof fileSchema>;
export type AudioDetail = z.infer<typeof audioDetailSchema>;

// EXPORTS
export const Schemes = { fileSchema, audioDetailSchema };

export type Types = {
  File: File;
  AudioDetail: AudioDetail;
};
